export const VIEW_MODES = {
  MOBILE: "mobile",
  DESKTOP: "desktop",
};
